import { createSelector } from 'reselect'

import { ApplicationState } from '../store/models'

export const currentUserSelector = (state: ApplicationState) => state.user
export const currentUserIdSelector = createSelector(currentUserSelector, (user) => user.id)
export const isVendorUserSelector = createSelector(currentUserSelector, (user) =>
  Boolean(user?.vendor_membership)
)
